// @givmo/board — the words the minute book's copy dialog adds to say which closed sessions a copy
// left out, and to let a current director include them (CBG-RC12-EXPORT-WEB; frames e1–e4, approved
// for building 2026-10-13 22:40 PDT, and their words on their copy page 2026-10-14 08:26 PDT).
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// Reused as approved: the readable copy's own section — its heading, its lead and "No general
// purpose recorded" (CBG-RC12-COPY1's second round, 2026-10-13 14:48 PDT, "4)ok"; the backend's
// `board_export_service.py` prints them) — and two lines of CBG-RC12-READ's frames, approved in the
// same round: d2's "Opening them is recorded in their history, with your name." and d3's "Opened by
// you, a director who wasn’t in this session". The rest, CBG-RC12-EXPORT-WEB's own, is approved as
// drafted on its copy page (`scratchpad/2026-10-13-frames1-copy-round/copy-review.html`,
// 2026-10-14 08:26 PDT, "approved if you agree with it"). The machine-readable copy's own
// lines (its title, count, fingerprint and "How this works") are CBG-UX1's and stay in
// `records-page.tsx`.
//
// ⚠ Plan §3.2 and §3.4 bind every line: what the copy holds and what including records, never a
// statement about what any closed session decided or whether anyone should read it.

export const exportWords = {
  // Approved (CBG-RC12-EXPORT-WEB's copy page, 2026-10-14), drawn e4: the readable copy's dialog,
  // beside the approved "Your machine-readable copy".
  readableTitle: 'Your readable copy',
  // Approved (CBG-RC12-COPY1), the readable copy's "NOT IN THIS EXPORT", shown in capitals as the
  // copy prints it. Drawn e1–e4.
  notInThisExport: 'Not in this export',
  // Approved (CBG-RC12-COPY1), the section's lead. Drawn e1–e4.
  keptForThePeople:
    'The minutes of these closed sessions are kept for the people who were in them:',
  // The approved line's own facts, "{meeting}, {day}" over its general purpose. Drawn e1–e4.
  meetingAndDay: (meeting: string, day: string) => `${meeting}, ${day}`,
  // Approved (CBG-RC12-COPY1, d1's state): a closed session recorded with no general purpose.
  noPurpose: 'No general purpose recorded',
  // Approved (CBG-RC12-EXPORT-WEB's copy page, 2026-10-14), drawn e2 and e4: to a current
  // director, above the button.
  youCanInclude: 'As a director, you can include them in your copy.',
  // Approved (CBG-RC12-COPY1, d2-open's second sentence), beside the line above.
  openingIsRecorded: 'Opening them is recorded in their history, with your name.',
  // Approved (CBG-RC12-EXPORT-WEB's copy page, 2026-10-14), drawn e2 and e4: the button.
  includeThemToo: 'Include them too',
  // After including them, over the list (drawn e3): d3's approved history line for one session, as a
  // lead; its plural, "these sessions", approved on the row's copy page (2026-10-14).
  openedByYou: (sessions: number) =>
    sessions === 1
      ? 'Opened by you, a director who wasn’t in this session:'
      : 'Opened by you, a director who wasn’t in these sessions:',
  // Approved (CBG-YR3-EXPORT's copy page, 2026-10-15; backend `board_records.md` §E12): "How this
  // works"'s third line, under the two reviewed ones. The copy carries the roster beside the
  // records, bound by no hash, so an unchanged fingerprint says nothing about it.
  rosterNotCovered:
    'It doesn’t cover the roster, which the copy carries as it stood when you took it.',
} as const;
